/**
 *   Generated file. Do not edit
 */

import { FirmwareState } from './models';
import { FirmwareUpdateResult } from './models';
import { CrcCheckBody } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readCrcCheckBody(): CrcCheckBody;
  }
  export interface TapStreamWriter {
    writeCrcCheckBody(model: CrcCheckBody): TapStreamWriter;
  }
}

TapStreamReader.prototype.readCrcCheckBody = function (): CrcCheckBody {
  const model: Partial<CrcCheckBody> = {};

  model.address = this.readUnsigned(4);

  model.size = this.readUnsigned(4);

  model.crc = this.readUnsigned(4);

  return model as CrcCheckBody;
};

// TapStreamWriter.prototype.write(model: CrcCheckBody) : TapStreamWriter{
//     return this.writeCrcCheckBody(model)
// }

TapStreamWriter.prototype.writeCrcCheckBody = function (
  model: CrcCheckBody,
): TapStreamWriter {
  this.writeUnsigned(model.address, 4);

  this.writeUnsigned(model.size, 4);

  this.writeUnsigned(model.crc, 4);

  return this;
};
